import { Button, Form, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useTranslation } from '../../i18n/i18n';

import UserForm from './UserForm';
import ModalCustom from '../utils/ModalCustom/ModalCustom';
import { UserAccountStatus, UserRole } from '../../gen/proto/api/gateway/v1/user_pb';
import { userApi } from '../../api/user.api';

interface EditUserModalProps {
  name: string;
  email: string;
  role: UserRole;
  uuid: string;
  state: UserAccountStatus;
  onSuccess?: () => void;
  tenantUuid?: string;
}

const EditUserModal = ({ name, email, role, state, uuid, onSuccess, tenantUuid }: EditUserModalProps) => {
  const { t } = useTranslation('users', { keyPrefix: 'modal' });
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  const handleSave = async () => {
    let values: { name: string; email: string; role?: UserRole; tenant?: string };
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    try {
      setIsLoading(true);
      const payload = {
        uuid,
        name: values.name,
        email: values.email,
        role: (values.role as UserRole) ?? role,
        tenantUuid: values.tenant ?? tenantUuid ?? '',
      };
      await userApi.updateUser(payload.uuid, payload.name, payload.email, payload.role, payload.tenantUuid);
      onSuccess?.();
    } catch (e) {
      messageApi.error(t('common:errors.generic'));
    } finally {
      setIsLoading(false);
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Button onClick={() => setIsModalOpen(true)} type={'text'}>
        <EditOutlined />
      </Button>
      <ModalCustom
        title={t('editUser')}
        description={t('editDesc')}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        footer={
          <Button type={'primary'} onClick={handleSave} loading={isLoading}>
            {t('save')}
          </Button>
        }
      >
        <UserForm
          form={form}
          name={name}
          email={email}
          role={role}
          state={state}
          tenantUuid={tenantUuid}
          onFinish={handleSave}
        />
      </ModalCustom>
    </>
  );
};

export default EditUserModal;
